import './Text.css';
import ShapeOfYouMP4 from './ShapeofYou.mp4'
import React, { useState } from 'react';

export function ShapeOfYou() {
    const [EuO98od978] = useState('EuO98od-978')
  return (
    <div class="body">
            <div class="row" >




<iframe  allow="fullscreen *"
frameborder="0"
        title='Freedom School'
        
        src={`https://youtube.com/embed/${EuO98od978}?autoplay=0`}>
</iframe>




      
      </div>      </div>
  );
}
